import { Search } from 'lucide-react'

import ReferralPageLinkButton from './ReferralPageLinkButton'
import CopyButton from '../reusable/CopyButton'

function EmployeesTableLoadingSkeleton ({ showReferralPageButtons, publicPageURL }: { showReferralPageButtons: boolean, publicPageURL: string }) {
  const widthClasses = ['w-1/2', 'w-3/5', 'w-3/4']

  const getRandomWidthClass = () => {
    const randomIndex = Math.floor(Math.random() * widthClasses.length)
    return widthClasses[randomIndex]
  }

  return (
    <div>
      <div className='flex items-center justify-between mb-3 w-full'>
        <div className='relative w-1/2 max-w-sm mt-2 rounded-md shadow-sm'>
          <div className='pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3'>
            <Search size={20} color='#9ca3af' />
          </div>
          <input
            id='search-clients'
            placeholder='Find clients'
            className='input-default pl-10'
            disabled
          />
        </div>
        {showReferralPageButtons && (
          <div className='flex gap-2'>
            <ReferralPageLinkButton publicPageURL={publicPageURL} />
            <CopyButton valueToCopy={publicPageURL} />
          </div>
        )}
      </div>
      <div className='-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8'>
        <div className='inline-block min-w-full py-2 align-middle md:px-6 lg:px-8'>
          <div className='overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg'>
            <table className='min-w-full divide-y divide-gray-200' id='employers-table'>
              <thead className='bg-white'>
                <tr>
                  {Array.from({ length: 5 }, (_, index) => (
                    <th key={index} className='py-3 px-2 text-left text-sm font-normal text-slate-700 sm:px-4'>
                      <div className='animate-pulse flex space-x-4'>
                        <div className='flex-1 space-y-4 py-1'>
                          <div className='h-4 bg-gray-200 rounded w-1/2' />
                        </div>
                      </div>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className='divide-y divide-gray-200 bg-white'>
                {Array.from({ length: 10 }, (_, index) => (
                  <tr key={index}>
                    {Array.from({ length: 5 }, (_, index) => (
                      <td key={index} className='whitespace-nowrap p-2 text-sm text-gray-600 sm:px-4'>
                        <div className='animate-pulse flex space-x-4'>
                          <div className='flex-1 space-y-4 py-1'>
                            <div className={`h-4 bg-gray-200 rounded ${getRandomWidthClass()}`} />
                          </div>
                        </div>
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  )
}

export default EmployeesTableLoadingSkeleton
